/*
* @Author: gujianghua
* @Date:   2018-08-23 19:52:26
* @Last Modified by:   gujianghua
* @Last Modified time: 2018-08-31 14:50:53
*/
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'

const v2 = BASE_API

export default {
	getList(params) {
		return service({
		  url: '/cloud/order/admin/listForAdmin',
		  method: 'get',
		  params: params
		})    
	},
	getMom(params) {
		return service({
		  url: '/cloud/uac/mom/manage/momList',
		  method: 'get',
		  params: params
		})    
	},
	getDoc(params, data) {
	    return service({
	      url: '/cloud/uac/doctorManager/getDoctorPage',
	      method: 'post',
	      params: params,
	      data: data
	    })
	},
	/**
	* [sendMsg 群发短信]
	* @param  {[obj]} params [同列表筛选条件]
	* @return {[obj]}
	*/
	sendMsg(data) {
	    return service({
	      url: '/cloud/order/sms/batchSendMsgForOrder',
	      method: 'post',
	      data: data
	    })   
	},
	sendMsgSingle(data) {
	    return service({
	      url: '/cloud/order/sms/sendMsg',
	      method: 'post',
	      data: data
	    })   
	},
	getTotal(params) {
		return service({
		  url: '/cloud/order/admin/summary',
		  method: 'get',
		  params: params
		})    
	},
	// 批量退款
	backAll(data) {
		return service({
		  url: '/cloud/order/batchRefund',
		  method: 'post',
		  data: data
		})    
	},
	// 单独退款
	back(data) {
		return service({
		  url: '/cloud/order/refund',
		  method: 'post',
		  data: data
		})    
	},
	// 获取订单信息
	getOrder(data) {
		return service({
		  url: '/cloud/order/admin/orderDetail/'+data,
		  method: 'get'
		})    
	},
	// 修改订单信息
	editOrder(data) {
		return service({
		  url: '/cloud/order/admin/orderModify',
		  method: 'post',
		  data: data
		})    
	},
	// 开发票
	createInvoice(data) {
		return service({
		  url: '/cloud/order/invoice/create',
		  method: 'post',
		  data: data
		})    
	},
  	//获取课程类型列表
  	getTypeList: (data) => {
	    return service({
	      url: '/cloud/course/v1/admin/course/product/type/list',
	      method: 'get',
	      params: data
	    })
	},
	/**
	* [export 导出]
	* @param  {[obj]} data [筛选条件]
	* @return {[obj]}
	*/
	exportExcel(params) {		
		return service({
			url: '/cloud/order/admin/exportForAdmin',
			method: 'get',
			params,
			responseType: 'blob'
		})
	},
	// 查看已退款
	refundInfo(params) {
		return service({
			url: '/cloud/order/refundInfo',
			method: 'get',
			params
		})
	},
	getPaySubjects(data) {
		return service({
		  url: '/cloud/uac/v1/collection/subject/findByPage',
		  method: 'post',
		  data
		})		
	},
}


// WEBPACK FOOTER //
// ./src/api/moneyManage/saleOrder.js